<div class="popup-box">
  <div class="multi-areas-popup">
    <span class="icon-close" (click)="closeMultiAreas()"></span>
    <h2 class="h-special">{{ 'Areas' | translate }}</h2>
    <div class="ctent-feedback">
      <div class="scroll-box">
        <table class="tbl-area">
          <tbody>
            <tr *ngFor="let area of data">
              <td>
                <span>
                  <img [src]="area.photo" onError="src='assets/images/no-image.png'" alt="Area">
                </span>
              </td>
              <td>{{ area.name.substr(0, 4) | translate }} {{ area.name.substr(5) }}{{ 'is' | translate }}
                <span [ngClass]="area.color">{{ area.noise_status | translate }}</span>
              </td>
              <td>{{ area.textTime }}</td>
              <td>
                <a routerLink="/area-detail/{{ area.id }}" class="more-detail" (click)="savePage(area.id)">{{ 'More Details' | translate }}</a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="bg-popup"></div>